import { Auth } from "shared/@auth/Auth";
import { useQuery } from "react-query";

export const useActiveTicketsQualified = (filters) => {
  const { makeAuthedRequest } = Auth.useContainer();

  return useQuery(
    ["activeTicketsQualified", filters],
    () => {
      const encodedOwners = filters.owners.map(encodeURIComponent).join(";");
      return makeAuthedRequest(
        `v1/reporting/qualified-attendance/type/${filters.type}/owner/${
          encodedOwners || null
        }/year/${filters.year}`,
        { method: "GET" }
      ).then((res) => res.json());
    },
    {
      enabled: !!filters,
      staleTime: 0,
      refetchOnWindowFocus: false,
    }
  );
};
